// extracted by mini-css-extract-plugin
export default {"PopupSideBar":"PopupSideBar_PopupSideBar__vB9dH"};